import { TAGS } from "./constants";

const DayDetails = ({
  date,
  timelogs,
  isLeave,
  onClose,
  onDelete,
  onEdit,
  onAddLeave,
  onRemoveLeave,
  onAddNew,
}) => {
  return (
    <div className="rounded-lg bg-white p-6 shadow-sm h-fit">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="text-lg font-bold text-slate-900">Day Details</h3>
        <button
          onClick={onClose}
          className="text-slate-400 hover:text-slate-600 text-xl"
        >
          ✕
        </button>
      </div>

      <div className="mb-4 text-sm text-slate-600">
        <strong>{date}</strong>
        {isLeave && (
          <span className="ml-2 inline-block rounded bg-red-100 px-2 py-1 text-red-700 text-xs">
            Leave
          </span>
        )}
      </div>

      {timelogs.length === 0 && !isLeave ? (
        <div className="mb-4 text-sm text-slate-500">No logs for this day</div>
      ) : (
        <div className="space-y-3 mb-4 max-h-96 pe-1 overflow-y-auto">
          {timelogs.map((log) => {
            const tag = TAGS.find((t) => t.id === log.tag);
            return (
              <div
                key={log.id}
                className="rounded-md border  border-slate-200 p-3"
              >
                <div className="flex items-start justify-between mb-1">
                  <div className="flex-1">
                    <p className="font-medium text-slate-900 text-sm">
                      {log.title}
                    </p>
                    <p className="text-xs text-slate-500">{log.duration}h</p>
                  </div>
                  <div className="flex gap-2 ml-2">
                    <button
                      onClick={() => onEdit(log.id)}
                      className="text-blue-500 hover:text-blue-700 text-xs"
                      title="Edit"
                    >
                      ✏️
                    </button>
                    <button
                      onClick={() => onDelete(log.id)}
                      className="text-red-500 hover:text-red-700 text-xs"
                      title="Delete"
                    >
                      🗑️
                    </button>
                  </div>
                </div>
                {tag && (
                  <span
                    className="inline-block text-xs font-medium rounded px-2 py-1 text-white"
                    style={{ backgroundColor: tag.color }}
                  >
                    {tag.label}
                  </span>
                )}
                {log.notes && (
                  <p className="text-xs text-slate-600 mt-2">{log.notes}</p>
                )}
              </div>
            );
          })}
        </div>
      )}

      <div className="space-y-2">
        {!isLeave && (
          <button
            onClick={onAddNew}
            className="w-full rounded-md bg-blue-600 px-3 py-2 text-sm font-medium text-white hover:bg-blue-700"
          >
            + Add Timelog
          </button>
        )}

        {isLeave ? (
          <button
            onClick={onRemoveLeave}
            className="w-full rounded-md bg-slate-200 px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-300"
          >
            Remove Leave
          </button>
        ) : (
          <button
            onClick={onAddLeave}
            className="w-full rounded-md bg-red-100 px-3 py-2 text-sm font-medium text-red-700 hover:bg-red-200"
          >
            Mark as Leave
          </button>
        )}
      </div>
    </div>
  );
};
export default DayDetails;
